import React, { useContext, useEffect, useState } from 'react'
import './AccountSettings.css'
import upload from '../../../../assets/upload.png'
import UserContext from '../../../../UserContext'
import axios from 'axios'
import LoadingScreen from '../../../../LoadingScreen'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faKey,
    faPenToSquare,
faSquareCheck
} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from 'react-toastify'
import { fetchSignInMethodsForEmail, sendPasswordResetEmail } from 'firebase/auth'
import bgUser from '../../../../assets/user.png'
import { auth, storage } from '../../../../firebase'
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage'


const AccountSettings = () => {
    const {userInfo,getUserDetails,userDetails,setChanges} = useContext(UserContext);
    const [profilePicture, setProfilePicture] = useState(null);
    const [activeOption,setActiveOption] = useState('details');
    // const [userDetails , setUserDetails] = useState();
    const [loading,setLoading] = useState(true);
    const [name,setName] = useState();
    const [role,setRole] = useState();
    const [mobile,setMobile]= useState();
    const [email,setEmail] = useState();
    const [conCode,setConCode] = useState();
    const [createdAt,setCreatedAt] = useState();
    const [editField,setEditField] = useState({name:false,mobile:false,email:false,country:false});
    const [picUrl,setPicUrl] = useState(null);
    const [country,setCountry] = useState(null);

    const handleOptions = (e) => {
        setActiveOption(() => e.target.id)
    }

    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const formattedDate = date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
        return formattedDate;
      }

    const getUserDetail = async (id) => {
        try {
            const res = await getUserDetails(id)
            setName(res.displayName)
            setRole(res.role)
            setMobile(res.phone.mobileNumber)
            setConCode(res.phone.code)
            setEmail(res.email)
            setCreatedAt(formatDate(res.createdAt))
            setLoading(false);
            setCountry(res.country)
            console.log(userDetails)
        } catch(err) {
            console.log(err);
        }
    }


    const updateDetails = async (pic) => {
        try {
            const body = {
                displayName : name,
                phone: {
                    code: conCode,
                    mobileNumber: mobile
                },
                country: country,
                picture: pic
            }
            await axios.put(`https://event-finder12.onrender.com/users/updateUser/${userInfo.email}`,body)
            setChanges(true);
            toast.success('Successfully updated user details')


        } catch(err) {
            toast.success(err)
            console.log(err);
        }
    }

    const handleEditName = () => {
        if(editField.name){
            updateDetails();
        }

        setEditField((prev) => ({ ...prev, name: !prev.name }));
        
      };




      const handleEditMobile = () => {
        if(editField.mobile)
            updateDetails();

        setEditField((prev) => ({ ...prev, mobile: !prev.mobile }));
      };


      const handleEditCountry = () => {
        if(editField.country)
            updateDetails();

        setEditField((prev) => ({ ...prev, country: !prev.country }));
      };

      const handleNameChange = (e) => {
        setName(e.target.value);
      }


      const handleMobileChange = (e) => {
        setMobile(e.target.value);
      }

      const handleCodeChange = (e) => {
        setConCode(e.target.value);
      }


      const handleCountryChange = (e) => {
        setCountry(e.target.value);
      }

  

      const handleUpload = () => {
        if (profilePicture) {
            const storage = getStorage();
            const storageRef = ref(storage, `profilePictures/${userInfo.uid}/${profilePicture.name}`);

            uploadBytes(storageRef, profilePicture)
            .then((snapshot) => {
              return getDownloadURL(storageRef);
            })
            .then((downloadURL) => {
              console.log('Profile picture uploaded successfully');
              console.log('Download URL:', downloadURL); 
              setPicUrl(downloadURL);
              updateDetails(downloadURL);
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
            toast.error("Select a picture before uploading")
        }
      };

      const handleFileChange = (e) => {
        const file = e.target.files[0];
        setProfilePicture(file);
      };
      

      const handleEmailChange = (e) => {
        setEmail(e.target.value)
      }

      const isEmailVerified = async (email) => {
        const user = await fetchSignInMethodsForEmail(auth, email);
        return user && user.length > 0;
      };


      const handlePasswordReset = async () => {
        try {
            const methods = await fetchSignInMethodsForEmail(auth, email);
            if (methods && methods.length > 0) {
              const isVerified = await isEmailVerified(email);
              console.log(isVerified);
              if (isVerified) {
                await sendPasswordResetEmail(auth, email);
                toast.success("Password Reset Email Sent");
              } else {
                toast.error("Email is not verified");
              }
            } else {
              toast.error("Email does not exist");
            }
          } catch (error) {
            toast.error("Error checking email existence:", error);
            console.log(error);
          }
      }


    useEffect(() => {
        if (userInfo.email) {
            getUserDetail(userInfo.email);
          }

          setPicUrl(userDetails.picture)
        }, [userInfo.email]);

  return (
    <div className='setting-outer-container'>
        <div className='setting-container'>
            <div className='setting-options'>
                <div onClick={(e)=> handleOptions(e)} id='details' className={activeOption==='details'?'setting-option active-option':'setting-option'}>User Details</div>
                <div onClick={(e)=> handleOptions(e)} id='login' className={activeOption==='login'?'setting-option active-option':'setting-option'}>Login & Security</div>
            </div>
            {loading ? <LoadingScreen/> : (<>
                <ToastContainer/>
                {activeOption==='details' ? (      <div className='picture-section'>
                <div className='profile-picture'>
                <h4 >Update Your Profile Picture</h4>
                <div className='file-input-container'>
                <label for="fileInput" class="custom-file-label">
    {!profilePicture ? <img src={upload} alt="Upload Icon" class="upload-icon"/> : <h5>{profilePicture.name.length > 10 ?  profilePicture.name.slice(0,10)+"..." : profilePicture.name}</h5> }
  </label>
  <input onChange={(e) => handleFileChange(e)} type="file" id="fileInput" class="hidden-file-input"/>
  <div onClick={handleUpload} className={profilePicture ? 'detail-edit-button upload-button' : 'detail-edit-button upload-button hidden'}>Upload &nbsp; <FontAwesomeIcon icon={faSquareCheck} style={{color: "#199438",}} />  </div>
                </div>
              
            </div>
            <div class="profile-picture bgPicture">
            <img src={picUrl || bgUser} alt="Profile Picture" class="profile-image" />
                </div>
                </div>) : <></>}
          
               
            {activeOption==='details' ? (<>
                <div className='profile-user-details'>
                <div className='user-detail'>
                    <h5 className='detail-label'>Name</h5>
                    <div className='detail-data'>
                    <input onChange={(e) => handleNameChange(e)} className={!editField.name ? 'input-field-user-detail readOnly' : 'input-field-user-detail'} readOnly={!editField.name} value={name} type='text'/>
                    <div onClick={handleEditName} className='detail-edit-button'>{!editField.name ? 'Edit' : 'Save'} {editField.name ? <FontAwesomeIcon icon={faSquareCheck} style={{color: "#199438",}} /> : <FontAwesomeIcon icon={faPenToSquare} />} </div>
                    </div>
                   
                </div>  
                <div className='user-detail'>
                    <h5 className='detail-label'>Role</h5>
                    <div className='detail-data'>
                    <input className='input-field-user-detail readOnly' readOnly  value={role} type='text'/>
                    <div></div>
                    </div>
                   
                </div>  
                <div className='user-detail'>
                    <div className='detail-label'>
                    <h5>Mobile No</h5>
                    <select onChange={(e) =>handleCodeChange(e)} value={conCode} disabled={!editField.mobile} className='option-number'>
                    
                    <option value="US">+1</option> 
                    <option value="FR">+33</option>
                    <option value="ES">+34</option>
                    <option value="IT">+39</option>
                    <option value="GB">+44</option>
                        <option value="IN">+91</option>
                    </select>
                    </div>
                    <div className='detail-data'>
                    <input type='number' onChange={(e)=> handleMobileChange(e)} value={mobile} className={!editField.mobile ? 'input-field-user-detail readOnly' : 'input-field-user-detail'} readOnly={!editField.mobile} />
                    <div onClick={handleEditMobile} className='detail-edit-button'>{!editField.mobile ? 'Edit' : 'Save'} {editField.mobile ? <FontAwesomeIcon icon={faSquareCheck} style={{color: "#199438",}} /> : <FontAwesomeIcon icon={faPenToSquare} />}</div>
                    </div>
                    
                </div>  
              
                <div className='user-detail'>
                    <h5 className='detail-label'>Country </h5>
                    <div className='detail-data'>
                    <select onChange={(e) =>handleCountryChange(e)} value={country} disabled={!editField.country} className='country-select-option'>
                    
                    <option value="US">USA</option>
                    <option value="CA">Canada</option>  
                    <option value="FR">France</option>
                    <option value="ES">Spain</option>
                    <option value="IT">Italy</option>
                    <option value="GB">Great Britain</option>
                        <option value="IN">India</option>
                    </select>

                   
          
                    <div onClick={handleEditCountry} className='detail-edit-button'>{!editField.country ? 'Edit' : 'Save'} {editField.country ? <FontAwesomeIcon icon={faSquareCheck} style={{color: "#199438",}} /> : <FontAwesomeIcon icon={faPenToSquare} />} </div>
                    
                    <div></div>
                    </div>
                    
                </div>  

                <div className='user-detail'>
                    <h5 className='detail-label'>Account Created on </h5>
                    <div className='detail-data'>
                    <input value={createdAt} className='input-field-user-detail readOnly' readOnly type='text'/>
                    <div></div>
                    </div>
                    
                </div> 
            </div>
            </>): <>
            <div className='profile-user-details'>
                <div className='user-detail'>
                    <h5 className='detail-label'>Email</h5>
                    <div className='detail-data'>
                    <input onChange={(e) => handleEmailChange(e)} className={!editField.email ? 'input-field-user-detail readOnly' : 'input-field-user-detail'} readOnly={!editField.email} value={email} type='email'/>
                    </div>
                   
                </div>  
                <div className='user-detail'>
                    <h5 className='detail-label'>Password</h5>
                    <div className='detail-data'>
                    <input className='input-field-user-detail readOnly' readOnly  value={role} type='password'/>
                    <div onClick={handlePasswordReset} className='detail-edit-button'> Reset <FontAwesomeIcon icon={faKey} /></div>
                    <div></div>
                    </div>
                   
                </div> 
                <div className='user-detail'> </div>
                <div className='user-detail'> </div>
                <div className='user-detail'> </div>
                <div className='user-detail'> </div>
                <div className='user-detail'> </div>
            </div>
            </>}
            </>)}
        </div>
    </div>
  )
}

export default AccountSettings